export var PLACEHOLDER_CHAR = '_';